import { connect } from 'react-redux';

import { setSwitchPfeSktAction } from '../actions/accountSettingsAction';
import {
  getSwitchPfeSkt,
  getSwitchPfeSktWaiting,
  getUserSubscription,
} from '../components/AccountSettings/AccountSettingsSelectors';
import PracticeExamPageView from '../components/PracticeExamPage/PracticeExamPageView';
import { getUser } from '../components/User/userSelectors';

const mapStateToProps = (state) => ({
  user: getUser(state),
  userSubscription: getUserSubscription(state),
  pfeSktId: getSwitchPfeSkt(state),
  pfeSktIdWaiting: getSwitchPfeSktWaiting(state),
});

const mapDispatchToProps = (dispatch) => ({
  setSwitchPfeSkt: (rateId) => dispatch(setSwitchPfeSktAction(rateId)),
});

const PracticeExamPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PracticeExamPageView);
export default PracticeExamPageContainer;
